import { Stack, Typography } from '@mui/material';

import { CounterStrip } from '@/components/shared/counterStrip';

interface ResourceSelectionManualViewerProps {
  include: string[];
  exclude: string[];
}

export const ResourceSelectionManualViewer = ({
  include,
  exclude,
}: ResourceSelectionManualViewerProps) => {
  return (
    <Stack width='100%' gap='24px'>
      <Typography variant='h4'>Manual overrides</Typography>
      <Stack gap={'12px'} width='240px'>
        <CounterStrip label='Included resources' count={include.length} />
        <CounterStrip label='Excluded resources' count={exclude.length} />
      </Stack>
    </Stack>
  );
};
